/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
    prefer-rest-params,
    radix,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const moduleDeps = [
  require('data/util').name,
  require('data/model/categorizerRule').name,
  require('data/service/location').name,
  'ngFileUpload',
];

const factory = function (Collection, CategorizerApi, CategorizerRule, benchLocation, Upload) {
  let CategorizerRuleCollection;
  return (CategorizerRuleCollection = (function () {
    CategorizerRuleCollection = class CategorizerRuleCollection extends Collection {
      static initClass() {
        this.prototype.$idName = 'clientId';
        this.prototype.$apiService = CategorizerApi;
        this.prototype.$type = CategorizerRule;
      }

      $url() {
        return `clientrules/client/${this.$storeId()}`;
      }

      $deleteUrl() {
        return 'clientrules';
      }

      $xlsUrl() {
        return `clientrules/xls/client/${this.$storeId()}`;
      }

      $serialize(data) {
        return data.map(row => Object.assign(row, { priority: parseInt(row.priority) }));
      }

      // Override these so they can't be called accidentally.
      $put() {}

      $post(file) {
        const rootUrl = benchLocation.apiRoot();
        return Upload.upload({
          sendFieldsAs: 'form',
          url: CategorizerApi.href(this.$xlsUrl()),
          file,
          withCredentials: true,
        });
      }

      $getIds() {
        return _.map(this.data, 'id');
      }

      $delete(ruleIds = []) {
        const apiCallObj = {
          headers: { 'Content-Type': 'application/json' },
          method: 'DELETE',
        };

        if (ruleIds.length) {
          _.assign(apiCallObj, {
            url: this.$deleteUrl(),
            data: ruleIds,
          });
        } else {
          _.assign(apiCallObj, { url: this.$url() });
        }

        return this.$apiCall(apiCallObj);
      }

      $init() {
        super.$init(...arguments);

        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }

      $groupByCategory() {
        return _.groupBy(this.data, rule =>
          typeof rule.$ledger === 'function' ? rule.$ledger().name : undefined,
        );
      }
    };
    CategorizerRuleCollection.initClass();
    return CategorizerRuleCollection;
  })());
};

module.exports = angular
  .module('bench.data.collection.CategorizerRule', moduleDeps)
  .factory('CategorizerRuleCollection', factory);
